import React from 'react';

const CSS = require('./Handle.module.scss');

interface HandleProps {
  onClick?: (event: any) => void;
}

function Handle({ onClick }: HandleProps) {
  return (
    <div className={CSS.HandleContainer}>
      <button className={CSS.Handle} onClick={onClick} />
    </div>
  );
}

export default Handle;
